import PageCommon from "./PageCommon.js";
import Pqp from "../3x1010/Pqp.js";
import Globals from "../Globals.js";
import MazeConst from "./maze/MazeConst.js";
import Maze from "./maze/Maze.js";
import RoomDesign from "./maze/design/RoomDesign.js";
import MazeRenderDebug from "./maze/MazeRenderDebug.js";
import Game from "./Game.js";


export default class PageDefault extends PageCommon {
	constructor() {
		super();
	}
	init() {
		super.init();
		
		/*this.quanteRows = 6;
		this.quanteCols = 6;*/
		//jQuery(window).on("click", this.start.bind(this))

		this.startGame();

	}
/*	start() {
		jQuery(window).off("click")
		this.nextMaze(false);
	}

	nextMaze(lInc) {
		let initer = this.getIniter(lInc)
		this.maze = new Maze(initer);
		this.maze.init();
		window.maze = this.maze;
	}

	mazeEventsHandler(e) {
		if (e.type === Maze.EVENT_MAZE_READY) {
			this.displayMaze();
		}
		if (e.type === Maze.EVENT_CREATING_ROOM) {
			jQuery(".js-msg").text("Creating room " + (e.data.iterations + 1));
		}
		if (e.type === Maze.EVENT_CHECKING_ROOM) {
			jQuery(".js-msg").text("Checking room " + (e.data.iterations + 1));
		}
		if (e.type === Maze.EVENT_CHECK_FOR_UNREACHABLE_ROOMS) {
			jQuery(".js-msg").text("Checking for unreachable rooms: " + (e.data.iterations + 1));
		}
		if (e.type === Maze.EVENT_CREATE_PATH_BLOCK) {
			jQuery(".js-msg").text("Creating paths, nodes remaining: " + (e.data.lasts));
		}
		if (e.type === Maze.EVENT_PATH_CREATED) {
			jQuery(".js-msg").text("Paths created");
		}
		if (e.type === Maze.EVENT_FIXING_ROOM_WALLS) {
			jQuery(".js-msg").text("Fixing the walls of the rooms: " + Math.floor((e.data.iterations + 1) / e.data.rows * 100) + "%");
		}
		if (e.type === Maze.EVENT_SETTING_UNREACHABLE_CELLS_AS_WALL) {
			jQuery(".js-msg").text("Setting unreachable cells as walls: " + Math.floor((e.data.iterations + 1) / e.data.rows * 100) + "%");
		}
		if (e.type === Maze.EVENT_LOOKING_FOR_ROOM_DOORS) {
			jQuery(".js-msg").text("Looking for the doors of the rooms: " + Math.floor((e.data.iterations + 1) / e.data.rows * 100) + "%");
		}
		if (e.type === Maze.EVENT_DIJKSTRA) {
			jQuery(".js-msg").text("Calculating distances with Dijkstra, nodes remaining: " + (e.data.lasts));
		}
		if (e.type === Maze.EVENT_DIJKSTRA_COMPLETED) {
			jQuery(".js-msg").text("Distances calculated with Dijkstra");
		}
		if (e.type === Maze.EVENT_FINDING_PATH) {
			jQuery(".js-msg").text("Calculating solution, nodes remaining: " + (e.data.lasts));
		}
		if (e.type === Maze.EVENT_PATH_FOUND) {
			jQuery(".js-msg").text("Path calculated");
		}
		if (e.type === Maze.EVENT_LOOKING_FOR_DEAD_ENDS) {
			jQuery(".js-msg").text("Looking for dead ends: " + Math.floor((e.data.iterations + 1) / e.data.rows * 100) + "%");
		}

	}


	getIniter(lInc) {

		if (lInc) {
			if (!this.incRow) {
				this.quanteRows++
				this.incRow = !this.incRow;
			} else {
				this.quanteCols += 2;
				this.incRow = !this.incRow;
			}
		}

		let rooms = this.getRooms(this.quanteRows, this.quanteCols, 2);
		let secret = Math.floor(rooms.length / 5);
		let n = 0;
		for (let x = 0; x < rooms.length; x++) {
			if (rooms[x].secret) {
				n++;
			}
		}

		if (secret < n) {
			secret = n;
		}

		let initer = {
			secretRooms: secret,
			rows: this.quanteRows,
			cols: this.quanteCols,
			rooms: rooms,
			eventsHandler: this.mazeEventsHandler.bind(this)
		}

		return initer;

	}

	getRooms(rows, cols, secretRooms) {
		let ret = new Array();
		let quante = Math.floor(rows * cols / 30)
		if (quante > 100) {
			quante = 100;
		}
		let nSecret = 0;

		let rooms = [
			{ size: MazeConst.ROOM_SIZE_SMALL, type: MazeConst.ROOM_TYPE_ONE_EXIT },
			{ size: MazeConst.ROOM_SIZE_SMALL, type: MazeConst.ROOM_TYPE_TWO_EXIT },
			{ size: MazeConst.ROOM_SIZE_SMALL, type: MazeConst.ROOM_TYPE_HALLWAY },
			{ size: MazeConst.ROOM_SIZE_MEDIUM, type: MazeConst.ROOM_TYPE_HALLWAY },
			{ size: MazeConst.ROOM_SIZE_MEDIUM, type: MazeConst.ROOM_TYPE_ONE_EXIT },
			{ size: MazeConst.ROOM_SIZE_MEDIUM, type: MazeConst.ROOM_TYPE_TWO_EXIT },
			{ size: MazeConst.ROOM_SIZE_LARGE, type: MazeConst.ROOM_TYPE_TWO_EXIT },
			{ size: MazeConst.ROOM_SIZE_LARGE, type: MazeConst.ROOM_TYPE_ONE_EXIT },
			{ size: MazeConst.ROOM_SIZE_LARGE, type: MazeConst.ROOM_TYPE_HALLWAY }
		]

		for (let x = 0; x < quante; x++) {
			let rm = rooms[Pqp.rnd(rooms.length - 1)]
			let lSecret = false;
			if (rm.type === MazeConst.ROOM_TYPE_ONE_EXIT) {
				if (Pqp.rnd(1) === 0) {
					if (nSecret < secretRooms) {
						lSecret = true;
					}
					nSecret++;
				}
			}
			ret.push({ size: rm.size, type: rm.type, secret: lSecret });
		}

		return ret;
	}

	displayMaze() {
		if (this.render) {
			this.render.destroy();
		}

		this.render = new MazeRenderDebug(this.maze, jQuery(".js-maze"), this.renderEventsHandler.bind(this));
		this.render.init();
		this.render.showSolution()
	}

	renderEventsHandler(e) {

		if (e.type === MazeRenderDebug.EVENT_MAZE_TRAVERSED_OK) {
			
			this.nextMaze(true);
		}

	}*/


	startGame() {
		this.game = new Game();
		this.game.init();
	}

}


